import { useEffect, useState } from "react";
import apiWithRefresh from "../utils/apiWithRefresh";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { useToast } from "../utils/useToast";
import GlobalToast from "../components/GlobalToast.jsx";
import { DataGrid } from "@mui/x-data-grid";
import { Helmet } from "react-helmet-async";
import assessmentStatusEnum from "../utils/assessmentstatusEnum.js";

const BatchAllocation = () => {
  const [enrollments, setEnrollments] = useState([]);
  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [toast, showToast] = useToast();
  const fetchEnrollmentsAndBatches = async () => {
    setLoading(true);
    setError(null);
    Promise.all([
      apiWithRefresh.get("learner-enrollments"),
      apiWithRefresh.get("batches"),
    ])
      .then(([enrollmentsData, batchesData]) => {
        setEnrollments(enrollmentsData);
        setBatches(batchesData);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchEnrollmentsAndBatches();
  }, []);

  const handleAllocate = async (enrollmentId, batchId) => {
    try {
      console.log("Allocating batch", { enrollmentId, batchId });
      await apiWithRefresh.patch(`learner-enrollments/${enrollmentId}/batch`, {
        batchAllocated: true,
        batchId: batchId,
      });
      showToast("Batch allocated successfully!", "success");
      // show Refresh enrollments and batches
      const updatedEnrollments = await apiWithRefresh.get("learner-enrollments");
      const updatedBatches = await apiWithRefresh.get("batches");
      setEnrollments(updatedEnrollments);
      setBatches(updatedBatches);
    } catch (err) {
      setError(err.message);
      showToast(err.message || "Batch allocation failed!", "error");
    }
  };

  return (
    <>
      <Helmet>
        <title>AKAAL KIDS - Admin Panel | Batch Allocation</title>
      </Helmet>
      <Box sx={{ p: 2, maxWidth: 1200, margin: "0 auto" }}>
        <Card elevation={2} sx={{ mt: 2 }}>
          <CardContent>
            <Typography variant="h4" gutterBottom>
              Batch Allocation
            </Typography>
            {loading && <Typography>Loading...</Typography>}
            {error && <Typography color="error">{error}</Typography>}
            <DataGrid
              autoHeight
              rows={enrollments
                .filter(
                  (en) =>
                    en.assessmentStatus === assessmentStatusEnum.PASS &&
                    en.admissionFeePaid === true  
                )
                .map((en) => ({
                  ...en,
                  id: en.id,
                  userName: en.learnerName || en.userId?.name || "",
                  levelName: en.preferredLevel?.name || "",
                  batchName: en.batchId
                    ? batches.find((b) => b.id === en.batchId)?.name || ""
                    : "Not allocated",
                }))}
              columns={[
                { field: "userName", headerName: "Learner", flex: 1 },
                { field: "email", headerName: "Email", flex: 1 },

                { field: "levelName", headerName: "Level", flex: 1 },
                //{ field: "batchName", headerName: "Current Batch", flex: 1 },                
                {
                  field: "allocateBatch",
                  headerName: "Allocate Batch",
                  sortable: false,
                  renderCell: (params) => (
                    <select disabled={params.row.batchAllocated}
                      value={params.row.batchId}
                      onChange={(e) =>
                        handleAllocate(params.row.id, e.target.value)
                      }
                      style={{ minWidth: 120, padding: "4px 8px" }}
                    >
                      <option value="">Select Batch</option>
                      {batches.map((batch) => (
                        <option key={batch.id} value={batch.id}>
                          {batch.name}
                        </option>
                      ))}
                    </select>
                  ),
                  flex: 1,
                }                
                ,
              ]}
              pageSize={10}
              rowsPerPageOptions={[10, 20, 50]}
              disableSelectionOnClick
            />
          </CardContent>
        </Card>
        <GlobalToast toast={toast} />
      </Box>
    </>
  );
};

export default BatchAllocation;
